var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xc-page xc-page-full"},[_c('div',{staticClass:"xc-page-main"},[_vm._m(0),_c('iframe',{staticStyle:{"width":"100%","visibility":"inherit","background-color":"#f8f8f8","z-index":"0"},attrs:{"src":_vm.path,"frameborder":"0","allowtransparency":"true"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xc-breadcrumb"},[_c('a',[_vm._v("首页")])])
}]

export { render, staticRenderFns }